import lib from '@/library'

const state = {
  race: undefined,
  racerp: undefined,
  racerc: undefined,
  totemr: undefined,
  showracedetails: false
}

const getters = {
  getRace (state) {
    return state.race
  },
  getRaceRp (state) {
    return state.racerp
  },
  getRaceRc (state) {
    return state.racerc
  },
  getToteMr (state) {
    return state.totemr
  },
  getShowRaceDetails (state) {
    return state.showracedetails
  }
}

const actions = {
  fetchRace (context, idtgrace) {
    var self = this
    context.commit('setRace', undefined)

    lib.kansas.toteRace({
      idtgrace: idtgrace
    }).then(response => {
      var race = response.data

      if (race && race.pools) {
        // Hide non-supported pool types
        race.poolsfordisplay = race.pools.filter(pool =>
          (pool.type === 'WIN' || self.getters['betslipState/getAvailableRPTypes'].indexOf(pool.type) === -1) &&
          (self.getters['betslipState/getAvailableRPTypes'].indexOf(pool.type) > -1 ||
            self.getters['betslipState/getAvailableRCTypes'].indexOf(pool.type) > -1 ||
            self.getters['betslipState/getAvailableMRTypes'].indexOf(pool.type) > -1))

        // Show non-supported pool types
        // race.poolsfordisplay = race.pools.filter(pool => pool.type !== 'PLACE')
      }

      context.commit('setRace', response.data)
    }).catch((error) => {
      console.log(error)
      context.commit('setRace', undefined)
    })
  },
  fetchRaceRp (context, idtgrace) {
    context.commit('setRaceRp', undefined)

    lib.kansas.toteRp({
      idtgrace: idtgrace
    }).then(response => {
      var race = response.data.race

      if (race) {
        race.runners.forEach(runner => {
          if (runner.guides) {
            runner.guides.forEach(guide => {
              if (guide.idtgpooltype === 'WIN') {
                runner.guidewin = guide
              } else if (guide.idtgpooltype === 'PLACE') {
                runner.guideplace = guide
              }
            })
          }
        })
      }

      context.commit('setRaceRp', response.data)
    }).catch((error) => {
      console.log(error)
      context.commit('setRaceRp', undefined)
    })
  },
  fetchRaceRc (context, idtgrace) {
    context.commit('setRaceRc', undefined)

    lib.kansas.toteRc({
      idtgrace: idtgrace
    }).then(response => {
      context.commit('setRaceRc', response.data)
    }).catch((error) => {
      console.log(error)
      context.commit('setRaceRc', undefined)
    })
  },
  fetchToteMr (context, idtgmeeting) {
    context.commit('setToteMr', undefined)

    lib.kansas.toteMr({
      idtgmeeting: idtgmeeting
    }).then(response => {
      context.commit('setToteMr', response.data)
    }).catch((error) => {
      console.log(error)
      context.commit('setToteMr', undefined)
    })
  },
  cleanRace (context) {
    context.commit('setRace', undefined)
  },
  cleanRaceRp (context) {
    context.commit('setRaceRp', undefined)
  },
  cleanToteMr (context) {
    context.commit('setToteMr', undefined)
  },
  toggleRaceDetails (context) {
    context.commit('toggleRaceDetails')
  },
  cleanRaceRc (context) {
    context.commit('setRaceRc', undefined)
  }
}

const mutations = {
  setRace (state, race) {
    state.race = race
  },
  setRaceRp (state, data) {
    state.racerp = data
  },
  setRaceRc (state, data) {
    state.racerc = data
  },
  setToteMr (state, data) {
    state.totemr = data
  },
  toggleRaceDetails (state) {
    state.showracedetails = !state.showracedetails
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/race.js